import { ReplaySubject } from 'rxjs/Rx';
import { NotificationsService } from 'angular2-notifications';
import { ServerProperty } from './../interfaces/server/server-property.model';
import { Server } from './../interfaces/server/server.model';
import { ResponseService } from './../services/response.service';
import { LocalStorageService } from './../services/local-storage.service';
import { IpmiService } from './../services/ipmi.service';
import { ApiService } from './../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-server-dashboard-info',
  templateUrl: './server-dashboard-info.component.html',
})
export class ServerDashboardInfoComponent implements OnInit {
  // ID serwera (ID elementu kontraktu);
  private serverID: String | null = null;

  // ID kontraktu
  private contractID: String | null = null;

  // Stan serwera
  public serverStatus: Boolean | null = null;

  // Zmienna odwiedlajaca czy pobierany lub zmieniany jest stan serwera
  public checkingStatus: Boolean = true;

  // Zmienna mówiąca o pobieraniu danych
  public loadingServerData: Boolean = true;

  // Parametry serwera
  public serverParameters: Array<ServerProperty>;

  // Obiekt serwera
  public server: Server;

  // Zmienna opisująca czy serwer jest gotowy
  public serverIsReadyObservable: ReplaySubject<Boolean> = new ReplaySubject(1);
  public serverIsReady: Boolean;

  constructor(
    private router: ActivatedRoute,
    private apiService: ApiService,
    private ipmiService: IpmiService,
    private localStorageService: LocalStorageService,
    private responseService: ResponseService,
    private notificationsService: NotificationsService
  ) { }

  ngOnInit() {
    this.serverIsReadyObservable.next(false);
    this.router.params.subscribe(params => {
      this.serverID = params['server_id'];
      this.contractID = params['id'];

      this.getServerInfo(this.contractID, this.serverID);

      this.serverIsReadyObservable.subscribe(
        (ready) => {
          this.serverIsReady = ready;
          if (ready) {
            this.apiService.getCSRFToken().then(token => {
              this.refreshServerStatus(this.serverID);
            });

            this.ipmiService.serverStatus.subscribe(
              (status) => {
                this.serverStatus = status;
              }
            );
          }
        });
    });
  }

  /**
   * Pobranie informacji o serwerze
   * 
   * @private
   * @param {String} contractID 
   * @param {String} serverID 
   * 
   * @memberOf ServerDashboardComponent
   */
  private getServerInfo(contractID: String, serverID: String): void {
    this.apiService.get('/company/' + this.localStorageService.get('company') + '/contract/' +
      contractID + '/item/' + serverID).subscribe(
      (response) => {
        const service = this.responseService.success(false, response, 'service');
        this.server = service.server;
        this.serverParameters = null;
        this.loadingServerData = false;
        this.serverIsReadyObservable.next(service.status === 'active');
      },
      (error) => {
        this.responseService.error(error);
      }
      );
  }

  /**
   * Odswiezenie statusu serwera
   * 
   * @private
   * @param {String} serverID 
   * 
   * @memberOf ServerDashboardComponent
   */
  private refreshServerStatus(serverID: String): void {
    this.checkingStatus = true;
    this.ipmiService.powerGet(serverID).then(
      (status) => {
        this.checkingStatus = false;
      },
      (error) => {
        this.notificationsService.error('Ups!', 'Błąd podczas pobierania informacji stanie serwera.');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/server/server-dashboard-info.component.ts